import { useTranslation } from 'react-i18next'
import { TemplateUpdateParams } from '../../../../types'
import { UseFormReturn } from 'react-hook-form'
import { SingleSelect } from '../../../../ui/form/SingleSelect'
import JsonField from '../../../../ui/form/JsonField'
import VariableTextInput from '../../../../ui/form/VariableTextInput'

export const WebhookForm = ({ form }: { form: UseFormReturn<TemplateUpdateParams, any> }) => {
    const { t } = useTranslation()
    return <>
        <SingleSelect.Field
            form={form}
            name="data.method"
            label={t('method')}
            options={['DELETE', 'GET', 'PATCH', 'POST', 'PUT']}
            required />
        <VariableTextInput.Field
            form={form}
            name="data.endpoint"
            label={t('endpoint')}
            required />
        <JsonField
            form={form}
            name="data.headers"
            label={t('headers')}
            textarea />
        <JsonField
            form={form}
            name="data.body"
            label={t('body')}
            textarea />
        <VariableTextInput.Field
            form={form}
            name="data.cache_key"
            label={t('cache_key')}
            subtitle={t('cache_key_subtitle')} />
    </>
}
